export default __webpack_public_path__ + "static/media/no-icon.7914b3e2.svg";